var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 432V96C21.49 96 0 117.492 0 144V448C0 483.344 28.654 512 64 512H432C458.51 512 480 490.508 480 464H80C62.326 464 48 449.672 48 432ZM512 0H160C124.654 0 96 28.654 96 64V352C96 387.346 124.654 416 160 416H512C547.346 416 576 387.346 576 352V64C576 28.654 547.346 0 512 0ZM224 116C224 122.625 218.625 128 212 128H172C165.375 128 160 122.625 160 116V76C160 69.375 165.375 64 172 64H212C218.625 64 224 69.375 224 76V116ZM512 116C512 122.625 506.625 128 500 128H268C261.375 128 256 122.625 256 116V76C256 69.375 261.375 64 268 64H500C506.625 64 512 69.375 512 76V116Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowsers);
export default __webpack_public_path__ + "static/media/browsers.13caeb673a7a98f6458c2a10aec6a4d8.svg";
export { ForwardRef as ReactComponent };